import React from "react";
import Chart from "react-apexcharts";
import {
  Card,
  CardBody,
  CardHeader,
  Typography,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

const PaymentMethodChart = ({ data = [] }) => {
  const { t } = useTranslation("home");
  const labels = data.map((item) => item.method);

  const series = data.map((item) => Number(item.count));

  const totalTransactions = series.reduce(
    (sum, value) => sum + value,
    0
  );

  const options = {
    chart: {
      type: "donut",
      toolbar: {
        show: false,
      },
    },

    labels,

    legend: {
      position: "bottom",
      fontSize: "14px",
    },

    dataLabels: {
      enabled: true,
    },

    stroke: {
      width: 2,
    },

    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],

    colors: [
      "#2563eb",
      "#10b981",
      "#f59e0b",
      "#ef4444",
      "#8b5cf6",
      "#06b6d4",
    ],

    plotOptions: {
      pie: {
        donut: {
          size: "68%",
          labels: {
            show: true,

            total: {
              show: true,
              // label: "Total",
              label: t('paymentMethods.totalLabel'),
            },
          },
        },
      },
    },

    tooltip: {
      y: {
        formatter: (value) => `${value} ${t('paymentMethods.transactions')}`,
      },
    },
  };

  return (
    <Card className="shadow-md">
      <CardHeader
        floated={false}
        shadow={false}
        className="rounded-none bg-white px-6 py-4"
      >
        <div className="flex justify-between items-center">
          <div>
            <Typography variant="h5">
              {t('paymentMethods.title')}
            </Typography>

            <Typography
              variant="small"
              color="gray"
            >
              {t('paymentMethods.description')}
            </Typography>
          </div>

          <Typography
            variant="h6"
            color="blue"
          >
            {totalTransactions} {t('paymentMethods.paymentsCount')}
          </Typography>
        </div>
      </CardHeader>

      <CardBody>
        <Chart
          options={options}
          series={series}
          type="donut"
          height={360}
        />
      </CardBody>
    </Card>
  );
};

export default PaymentMethodChart;